import { auth } from '../../actionTypes';

const initialState = {
  loading: false,
};

export default function setNewPassword(state = initialState, action) {
  switch (action.type) {
    case auth.setNewPassword.start:
      return { ...state, loading: true };

    case auth.setNewPassword.end:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
